/**
 * New-auth provider ids + predicates (CURI-334).
 *
 * Kept dependency-free (no `next-auth/providers` imports) so client code — e.g.
 * useSignOut — can import the predicates without pulling next-auth's Node-only
 * server deps (openid-client → net/tls/child_process) into the browser bundle.
 * The actual provider builders live in `newAuthProviders.ts` (server-only).
 */

/** Direct-OAuth providers — their callbacks go through /federated/exchange. */
export const OAUTH_NEW_PROVIDER_IDS = ['google', 'clever', 'classlink', 'feide'] as const;

/** All new-auth provider ids (OAuth + the magic-link credentials provider). */
export const NEW_AUTH_PROVIDER_IDS = [...OAUTH_NEW_PROVIDER_IDS, 'magic-link'] as const;

export type NewAuthProviderId = typeof NEW_AUTH_PROVIDER_IDS[number];

export const isOAuthNewProvider = (id?: string): boolean =>
  !!id && (OAUTH_NEW_PROVIDER_IDS as readonly string[]).includes(id);

export const isNewAuthProvider = (id?: string): id is NewAuthProviderId =>
  !!id && (NEW_AUTH_PROVIDER_IDS as readonly string[]).includes(id);
